// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-brand {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.header-brand img {\n  height: 26px;\n  padding-right: 15px;\n  margin-right: 15px;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n  position: relative;\n  top: -1px;\n}\n", ""]);
// Exports
module.exports = exports;
